/* ============================================================
   MES MÉMOIRES — chatbot.js
   Chatbot uniquement. La lightbox des livres est gérée par chaque page collection pour éviter les conflits.
   ============================================================ */

'use strict';

/* ══════════════════════════════════════════════════════════════
   CHATBOT
   ══════════════════════════════════════════════════════════════ */
(function initChatbot() {
  const chatBtn    = document.getElementById('chatBtn');
  const chatPanel  = document.getElementById('chatPanel');
  const chatClose  = document.getElementById('chatClose');
  const chatInput  = document.getElementById('chatInput');
  const chatSend   = document.getElementById('chatSend');
  const chatMsgs   = document.getElementById('chatMessages');
  const quickBtns  = document.getElementById('chatQuickBtns');

  if (!chatBtn || !chatPanel) return;
  if (chatInput && !chatInput.getAttribute('aria-label')) {
    chatInput.setAttribute('aria-label', 'Votre message');
  }

  const homeHref = (hash) => '/' + hash;
  const pageHref = (page) => '/pages/' + String(page).replace(/\.html$/, '');

  // ── Réponses prédéfinies ─────────────────────────────────────
  const FAQ = {
    'prix':       'Les livres individuels sont à **24,99 €**. L’offre **2 livres individuels achetés = le 3e offert** s’applique uniquement aux livres non remisés, hors packs, lots, formats duo et collections déjà en promotion.',
    'livraison':  'Livraison suivie dans toute la France ✅. Comptez **3 à 7 jours ouvrés** pour la France métropolitaine, et jusqu\'à 15 jours pour l\'international.',
    'maman':      `Nous avons **4 modèles** pour Maman : Marbre (bestseller ⭐), Jungle, Tournesols et Tropical rose. Chacun à 24,99 €. Voir la collection ici → [Nos Livres](${homeHref('#produits')})`,
    'retour':     `Vous disposez de **14 jours** après réception pour retourner un produit non utilisé. Remboursement sous 14 jours. Voir notre [politique de remboursement](${pageHref('remboursement.html')}).`,
    'mesure':     `Notre **Conciergerie Émotionnelle** vous permet de créer un livre 100% personnalisé : thème, couverture, ambiance… sur devis. [En savoir plus](${pageHref('conciergerie.html')}) 🌟`,
    'amp':        'Notre livre **AMP/FIV** est un journal intime pensé pour accompagner le parcours AMP/FIV — émotions, attentes, injections, pensées. Format poche 110×170 mm, 163 pages. 24,99 €.',
    'audio':      'Votre histoire peut être narrée en version audio : voix, musique d\'ambiance, effets sonores. Contactez-nous pour un devis sur mesure ! 🎵',
    'couple':     'Nous avons **2 modèles** pour les couples : Marbre et Tropical. Journaux de couple à compléter sur 5 ans, 372 pages, 24,99 €.',
    'contact':    `Vous pouvez nous écrire via le [formulaire de contact](${homeHref('#contact')}), ou directement par WhatsApp en cliquant sur le bouton vert ci-dessous. Nous répondons sous 48h.`,
    'paiement':   'Paiement 100% sécurisé par cryptage SSL. Nous acceptons les cartes bancaires (Visa, Mastercard, Amex) et PayPal. 🔒',
  };

  const KEYWORDS = {
    'prix|tarif|coût|combien': 'prix',
    'livraison|délai|expédition|livrer': 'livraison',
    'maman|mère|maman|mères': 'maman',
    'retour|remboursement|rembourser|annuler': 'retour',
    'mesure|personnalisé|conciergerie|sur mesure': 'mesure',
    'amp|fiv|parcours|invisible': 'amp',
    'audio|musique|narration|chanson': 'audio',
    'couple|amour|partenaire|conjoint': 'couple',
    'contact|email|joindre|répondre': 'contact',
    'paiement|payer|carte|sécurisé': 'paiement',
  };

  function detectTopic(text) {
    const lower = text.toLowerCase();
    for (const [pattern, topic] of Object.entries(KEYWORDS)) {
      if (new RegExp(pattern).test(lower)) return topic;
    }
    return null;
  }

  // ── State ────────────────────────────────────────────────────
  let isOpen = false;
  let history = [
    { role: 'system', content: `Tu es l'assistant virtuel de Mes Mémoires, une boutique française de livres de souvenirs, de journaux guidés et de carnets émotionnels. Tu es chaleureux, élégant, et tu parles en français. Tu réponds de façon concise (3-4 phrases max). Les livres individuels coûtent 24,99€. L'offre 2 livres individuels achetés = le 3e offert est valable uniquement sur les livres non remisés, hors packs, lots, formats duo, collections déjà remisées et promotions en cours. Livraison suivie en France. Si on te demande de parler à un humain, dis que le client peut cliquer sur le bouton WhatsApp vert.` }
  ];

  // ── Toggle ───────────────────────────────────────────────────
  chatBtn.addEventListener('click', () => {
    isOpen = !isOpen;
    chatPanel.classList.toggle('open', isOpen);
    if (isOpen) {
      chatInput.focus();
      const bubbleLabel = document.querySelector('.chat-bubble-label');
      if (bubbleLabel) bubbleLabel.style.display = 'none';
    }
  });

  chatClose.addEventListener('click', () => {
    isOpen = false;
    chatPanel.classList.remove('open');
  });

  // ── Quick buttons ─────────────────────────────────────────────
  quickBtns.querySelectorAll('.chat-quick-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const q = btn.dataset.q;
      sendMessage(q);
      quickBtns.style.display = 'none'; // cacher après 1 clic
    });
  });

  // ── Send ─────────────────────────────────────────────────────
  chatSend.addEventListener('click', () => {
    const msg = chatInput.value.trim();
    if (msg) { sendMessage(msg); chatInput.value = ''; }
  });

  chatInput.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      const msg = chatInput.value.trim();
      if (msg) { sendMessage(msg); chatInput.value = ''; }
    }
  });

  // ── Ajouter message ───────────────────────────────────────────
  function addMsg(text, role) {
    const div = document.createElement('div');
    div.className = 'chat-msg chat-msg--' + role;
    div.innerHTML = text
      .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
      .replace(/\[(.*?)\]\((.*?)\)/g, '<a href="$2" style="color:var(--gold-dark);text-decoration:underline">$1</a>');
    chatMsgs.appendChild(div);
    chatMsgs.scrollTop = chatMsgs.scrollHeight;
    return div;
  }

  function addTyping() {
    const div = document.createElement('div');
    div.className = 'chat-msg chat-msg--typing';
    div.innerHTML = '<div class="chat-typing-dots"><span></span><span></span><span></span></div>';
    chatMsgs.appendChild(div);
    chatMsgs.scrollTop = chatMsgs.scrollHeight;
    return div;
  }

  // ── Envoyer message ───────────────────────────────────────────
  async function sendMessage(text) {
    addMsg(text, 'user');
    chatInput.disabled = true;
    chatSend.disabled  = true;

    const typing = addTyping();

    // Vérifier FAQ locale d'abord
    const topic = detectTopic(text);
    if (topic && FAQ[topic]) {
      await new Promise(r => setTimeout(r, 700));
      typing.remove();
      addMsg(FAQ[topic], 'bot');
      chatInput.disabled = false;
      chatSend.disabled  = false;
      chatInput.focus();
      return;
    }

    await new Promise(r => setTimeout(r, 650));
    typing.remove();
    addMsg(
      `Je peux vous guider sur les questions fréquentes : tarifs, livraison, livres, audio, sur mesure ou contact. Pour une demande précise, écrivez-nous via le [formulaire de contact](${homeHref('#contact')}) ou utilisez le bouton WhatsApp ci-dessous.`,
      'bot'
    );

    chatInput.disabled = false;
    chatSend.disabled  = false;
    chatInput.focus();
  }

})();


/* ══════════════════════════════════════════════════════════════
   3. SCROLL TO TOP (global pour toutes les pages)
   ══════════════════════════════════════════════════════════════ */
(function initScrollTopGlobal() {
  let btn = document.getElementById('scrollTop');
  if (!btn) {
    btn = document.createElement('button');
    btn.className = 'scroll-top';
    btn.id = 'scrollTop';
    btn.setAttribute('type', 'button');
    btn.setAttribute('aria-label', 'Retour en haut de page');
    btn.innerHTML = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 15l-6-6-6 6"/></svg>';
    document.body.appendChild(btn);
  }
  window.addEventListener('scroll', () => {
    btn.classList.toggle('visible', window.scrollY > 400);
  }, { passive: true });
  btn.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();
